import HttpClient from '@/util/http/HttpClient';
import GraphQlApi from '@/api/graph/GraphQlApi';
import GlossRepository from '@/api/GlossRepository';
import UserRepository from '@/api/UserRepository';
import GlobalState from '@/util/GlobalState';
import BookRepository from '@/api/BookRepository';
import FileRepository from '@/api/FileRepository';

const mjegbEndpoint = process.env.VUE_APP_MJEGB_ENDPOINT!;
const loginEndpoint = mjegbEndpoint + '/oauth2/authorization/ngc-auth';
const logoutEndpoint = mjegbEndpoint + '/oauth2/logout';
export const ngtApiEndpoint = mjegbEndpoint + '/ngt-api';
const apiEndpoint = mjegbEndpoint + '/api';
const httpClient = new HttpClient({});
const graphQlApi = new GraphQlApi(httpClient, ngtApiEndpoint);
export const glossRepository = new GlossRepository(graphQlApi);
export const userRepository = new UserRepository(httpClient, apiEndpoint, logoutEndpoint);
export const bookRepository = new BookRepository(httpClient, apiEndpoint);
export const fileRepository = new FileRepository(httpClient, apiEndpoint);
export const globalState = new GlobalState(userRepository, loginEndpoint);
export const PAGE_DEFAULT_PAPER_TYPE = 'a4';
export const PAGE_DEFAULT_ORIENTATION = 'portrait';
export const PAGE_DEFAULT_LAYOUT = '3x2';
export const PAGE_DEFAULT_FONT_TYPE = 'open-sans';
export const PAGE_DEFAULT_FONT_SIZE = 10;
export const MESSAGE_DURATION_DEFAULT = 2500;
